module.exports = __webpack_public_path__ + "static/img/my.7d825baf.svg";